<template>
  <DialogFull
    :data="dialogSettings"
    @close="close"
    progress
    @onStepBack="stepBack"
    :steps="{ current: step, total: totalSteps }"
  >
    <template v-slot:dialog.body>
      <div class="schedule-interview-dialog container col-lg-8 col-sm-12">
        <BasicDetails
          ref="step1"
          v-if="shouldStepViewBeShown(1) || ifStepHasAlreadyBeenCompleted(1)"
          v-show="shouldStepViewBeShown(1)"
          @onChange="updateData"
        />
        <InterviewSlot
          :interviewFormatId="interviewSlotData.interviewFormatId"
          ref="step2"
          v-if="shouldStepViewBeShown(2) || ifStepHasAlreadyBeenCompleted(2)"
          v-show="shouldStepViewBeShown(2)"
          @onChange="updateData"
        />
      </div>
    </template>
    <template v-slot:dialog.action>
      <PrimaryButton
        @click.native="validateStep"
        :loading="isCreatingInterviewSlot"
      >
        {{ buttonText }}
      </PrimaryButton>
    </template>
  </DialogFull>
</template>

<script>
import DialogFull from "@/components/common/DialogFull";
import InterviewSlot from "@/views/bookings/BookingInterviews/components/dialogs/ScheduleInterview/steps/InterviewSlot";
import BasicDetails from "@/views/bookings/BookingInterviews/components/dialogs/ScheduleInterview/steps/BasicDetails";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import { INTERVIEWS_NAMESPACE } from "@/store/modules/bookings/interviews";
import { CREATE_INTERVIEW_SLOT } from "@/store/modules/bookings/interviews/actions";
import { createNamespacedHelpers } from "vuex";
import { map } from "lodash";

const { mapActions: mapInterviewActions } = createNamespacedHelpers(
  INTERVIEWS_NAMESPACE
);

export default {
  name: "ScheduleInterview",
  components: {
    PrimaryButton,
    DialogFull,
    BasicDetails,
    InterviewSlot
  },
  data() {
    return {
      totalSteps: 2,
      step: 1,
      savedStep: 1,
      interviewSlotData: {
        candidateAdditionalDetails: "",
        interviewerAdditionalDetails: "",
        interviewers: [],
        candidate: null,
        slot: null,
        interviewFormatId: null
      },
      isCreatingInterviewSlot: false
    };
  },
  computed: {
    dialogSettings() {
      return {
        dialog: this.isOpen,
        title: "Schedule Interview"
      };
    },
    buttonText() {
      return this.step < this.totalSteps ? "Continue" : "Schedule Interview";
    }
  },
  methods: {
    ...mapInterviewActions({
      createInterviewSlot: CREATE_INTERVIEW_SLOT
    }),
    updateData({ key, value }) {
      this.interviewSlotData[key] = value;
    },
    stepForward() {
      this.step += 1;
      if (this.savedStep < this.totalSteps && this.step > this.savedStep) {
        this.savedStep += 1;
      }
    },
    stepBack() {
      if (this.step > 1) {
        this.step -= 1;
      }
    },
    shouldStepViewBeShown(viewStep) {
      return viewStep <= this.totalSteps && this.step === viewStep;
    },
    ifStepHasAlreadyBeenCompleted(viewStep) {
      return viewStep <= this.savedStep;
    },
    async validateStep() {
      const isStepValid = await this.$refs[`step${this.step}`].validateForm();
      if (isStepValid) {
        if (this.step === this.totalSteps) {
          this.handleSubmit();
        } else {
          this.stepForward();
        }
      }
    },
    async handleSubmit() {
      const {
        slot: { startTime, endTime },
        interviewers,
        candidate,
        location,
        candidateAdditionalDetails,
        interviewerAdditionalDetails,
        interviewFormatId
      } = this.interviewSlotData;
      this.isCreatingInterviewSlot = true;
      const { data } = await this.createInterviewSlot({
        interviewSlot: {
          startTime,
          endTime,
          interviewers: map(interviewers, id => ({
            id
          })),
          candidate: {
            id: candidate
          },
          ...(location && {
            location
          }),
          candidateAdditionalDetails,
          interviewerAdditionalDetails
        },
        interviewFormatId
      });
      this.close();
      if (data) {
        this.$router.push(`interviews/${data.id}`);
      }
      this.isCreatingInterviewSlot = false;
    },
    close() {
      this.$emit("close");
    }
  },
  props: {
    isOpen: Boolean
  }
};
</script>

<style lang="scss"></style>
